import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=615b58f1&scoped=true&"
import script from "./h5.vue?vue&type=script&lang=js&"
export * from "./h5.vue?vue&type=script&lang=js&"
import style0 from "./h5.vue?vue&type=style&index=0&id=615b58f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b58f1",
  null
  
)

export default component.exports